/**
 * Production-safe logging utility
 * Only logs in development, silent in production
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  info: (...args) => {
    if (isDevelopment) {
      console.log('[INFO]', ...args);
    }
  },
  
  warn: (...args) => {
    if (isDevelopment) {
      console.warn('[WARN]', ...args);
    }
  },
  
  error: (...args) => {
    // Always log errors, but in production send to monitoring service
    if (isDevelopment) {
      console.error('[ERROR]', ...args);
    } else {
      // In production, send to error monitoring service (e.g., Sentry)
      // For now, just silent or log to backend
      // TODO: Integrate with error monitoring service
    }
  },
  
  debug: (...args) => {
    if (isDevelopment) {
      console.debug('[DEBUG]', ...args);
    }
  }
};

export default logger;
